export default {
  methods: {
    parseMarkup(text) {
      if (!text) return [];

      const allowedUrlProtocols = ['http:', 'https:', 'mailto:', 'tel:'];
      const inlineTokenPattern = /\*\*(.+?)\*\*|\[([^\]]+)\]\(([^)]+)\)/g;
      const orderedListPattern = /^\d+\.\s+(.*)/;
      const unorderedListPattern = /^[-*]\s+(.*)/;

      const isSafeUrl = (value) => {
        try {
          const url = new URL(value, window.location.origin);
          return allowedUrlProtocols.includes(url.protocol);
        } catch (e) {
          return false;
        }
      };

      const parseInline = (line) => {
        const tokens = [];
        let lastIndex = 0;
        let match;

        inlineTokenPattern.lastIndex = 0;
        while ((match = inlineTokenPattern.exec(line)) !== null) {
          if (match.index > lastIndex) {
            tokens.push({ type: 'text', value: line.slice(lastIndex, match.index) });
          }

          const [fullMatch, boldValue, linkLabel, linkUrl] = match;

          if (boldValue !== undefined) {
            tokens.push({ type: 'bold', value: boldValue });
          } else if (isSafeUrl(linkUrl)) {
            tokens.push({ type: 'link', label: linkLabel, url: linkUrl });
          } else {
            tokens.push({ type: 'text', value: fullMatch });
          }

          lastIndex = match.index + fullMatch.length;
        }

        if (lastIndex < line.length) {
          tokens.push({ type: 'text', value: line.slice(lastIndex) });
        }

        return tokens;
      };

      const lines = text.split(/\r\n|\r|\n/);
      const blocks = [];
      let currentParagraphLines = null;
      let currentList = null;

      const closeList = () => {
        if (currentList) {
          blocks.push(currentList);
          currentList = null;
        }
      };

      const closeParagraph = () => {
        if (currentParagraphLines) {
          blocks.push({ type: 'paragraph', lines: currentParagraphLines });
          currentParagraphLines = null;
        }
      };

      lines.forEach((line) => {
        const trimmedLine = line.trim();

        if (!trimmedLine) {
          closeList();
          closeParagraph();
          return;
        }

        const orderedMatch = trimmedLine.match(orderedListPattern);
        const unorderedMatch = trimmedLine.match(unorderedListPattern);

        if (orderedMatch || unorderedMatch) {
          closeParagraph();

          const listType = orderedMatch ? 'ol' : 'ul';
          const itemText = orderedMatch ? orderedMatch[1] : unorderedMatch[1];

          if (!currentList || currentList.listType !== listType) {
            closeList();
            currentList = { type: 'list', listType, items: [] };
          }
          currentList.items.push(parseInline(itemText));
          return;
        }

        closeList();
        if (!currentParagraphLines) {
          currentParagraphLines = [];
        }
        currentParagraphLines.push(parseInline(trimmedLine));
      });

      closeList();
      closeParagraph();

      return blocks;
    },
  },
};
